<template>
  <div>
    <v-container fluid :class="$vuetify.breakpoint.mdAndUp ? 'px-5' : 'px-3'">
      <v-col cols="12" class="px-0">
        <v-card class="datSectionTable">
          <!-- Cabecera de Tabla -->
          <v-card-title class="py-3">
            <v-col cols="6" md="3" class="order-2 order-md-1 py-1 mr-auto mt-auto" >
              <v-text-field v-model="dSearch" prepend-inner-icon="mdi-magnify" color="datPrimary" class="mt-0 py-0" :placeholder="$t('labels.search')" single-line hide-details></v-text-field>
            </v-col>
            <v-col v-if="pComplaintInfo.status != 'RESUELTA' && pComplaintInfo.status != 'RECHAZADA'" cols="6" md="auto" class="order-1 order-md-2 py-1" >
              <v-btn dark depressed class="datPrimaryBtn"  @click="fNewTask()">
                {{$t('btn.newTask')}}
              </v-btn>
            </v-col>
          </v-card-title>
          <!-- Listado DragnDrop -->
          <v-card-text class="py-4">
            <v-data-table :headers="dTaskTableHeaders" 
                          :items="dTasks" 
                          :loading="dLoadingTable" 
                          :item-key="dItemKey" 
                          :noDataText="$t('datGeneric.noData')" 
                          :loading-text="$t('labels.loadingItems')" 
                          :header-props="dHeaderProps"
                          :show-select="false"
                          :disable-pagination="true"
                          :hide-default-footer="true"
                          class="datTable" >
              <template v-slot:progress>
                <v-progress-linear v-if="dLoadingTable" color="datPrimary" indeterminate height="2"></v-progress-linear>
              </template>

              <!-- Filas draggables -->
              <template v-slot:body="taskArray">
              <draggable :list="taskArray.items" tag="tbody" @change="fReorderTasks(taskArray.items)" >
                <tr v-for="(task, index) in taskArray.items" :key="index">
                  <td> 
                    <p class="fs12 fcC1"> {{task.taskOrder+1}}</p> 
                  </td>                 
                  <td>
                    <p class="fs12 fcC1"> {{task.taskTitle}}</p> 
                  </td>
                  <td>                    
                    <p class="fs12 fcC1">{{task.responsible}}</p>
                  </td>
                  <td>                      
                    <p class="fs12 fcC1">{{fDateFormat2(task.prevEndDate)}}</p>
                  </td>                   
                  <td>
                    <v-chip small :color="fGetStatusColor(task.status)">{{ task.status }}</v-chip>
                  </td>
                  <td>
                    <!-- Botón editar tarea -->
                    <v-tooltip color="datSecondary" bottom>
                      <template v-slot:activator="tooltip">
                        <v-btn icon class="datPrimaryBtnIcon" @click="fOpenTaskDetail(task)" v-on="tooltip.on">
                          <v-icon size="22">mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                        <span>{{$t('btn.taskDetail')}}</span>
                    </v-tooltip>
                    <!-- Botón reordenar -->
                    <v-tooltip v-if="fShowActions()" color="datSecondary" bottom>
                      <template v-slot:activator="tooltip">
                        <v-btn icon class="datPrimaryBtnIcon" v-on="tooltip.on">
                          <v-icon size="22">mdi-order-bool-descending</v-icon>
                        </v-btn>
                      </template>
                        <span>{{$t('btn.reorder')}}</span>
                    </v-tooltip>                    
                    <!-- Botón borrar tarea -->
                    <v-tooltip v-if="task.status == 'PENDIENTE' && fShowActions()" color="datSecondary" bottom>
                      <template v-slot:activator="tooltip">
                        <v-btn icon class="datDeleteBtnIcon" v-on="tooltip.on" @click="fDeleteTaskAlert(task)">
                          <v-icon size="22">mdi-delete</v-icon>
                        </v-btn>
                      </template>
                        <span>{{$t('labels.remove')}}</span>
                    </v-tooltip>                     
                  </td>
                </tr>
              </draggable>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-container>

    <!-- Modal detalle de tarea -->
    <datModal v-if="dShowTaskDetail" v-model="dShowTaskDetail" :pWidth="800" :pTitle="$t('btn.taskDetail')">
      <eComplaintTaskDetail :pSelectedTask="dSelectedTask" :pComplaintId="pComplaintInfo.complaintId" @close="fCloseTaskDetail"/>
    </datModal>
  </div>
</template>
<script>

//Servicios
import ServiceEcomplaints from '@/services/srv-eComplaints'
import mxCanalDenuncias from '@/mixins/mxCanalDenuncias.vue'

// Componentes
import eComplaintTaskDetail from '@/components/EComplaints/complaintDetail/modals/eComplaintTaskDetail'
import draggable from 'vuedraggable'
import datModal from '@/components/datModal'

export default {
  mixins: [mxCanalDenuncias],

  components: {
    eComplaintTaskDetail,
    datModal,
    draggable
  },

  mounted(){
    this.fInitTable()
  },

  props: {
    pComplaintInfo:{
      type: Object,
      required: false
    },
    pShowSnackbar:{
      type: String,
      default: 'BOTH' // SON PARENT BOTH
    },    
  },

  data () {
    return {
      dSearch:'',
      dCurrentSearchTime: null,
      dTasks: [],
      dSelectedTask: {},
      dShowTaskDetail: false,
      dSelectedComplaint: {},
      dHeaderProps: {sortByText: this.$t('datGeneric.sortBy')},
      dTaskTableHeaders: [
        { text: this.$t('datTableHeader.order'),          value: 'taskOrder',   align: 'left',  sortable: true,   class: ''},
        { text: this.$t('datTableHeader.taskTitle'),      value: 'taskTitle',   align: 'left',  sortable: true,   class: ''},
        { text: this.$t('datTableHeader.responsible'),    value: 'responsible', align: 'left',  sortable: true,   class: ''},
        { text: this.$t('datTableHeader.prevEndDate'),    value: 'prevEndDate', align: 'left',  sortable: true,   class: ''},
        { text: this.$t('datTableHeader.status'),         value: 'status',      align: 'left',  sortable: true,   class: ''},
        { text: this.$t('datTableHeader.actions'),        value: 'actions',     align: 'left',sortable: false,  class: ''}
      ],
      dItemKey: 'taskTitle',
      dLoadingTable: false
    }
  },
  methods: {
    
    // Inicializa al componente
    fInitTable(){
      this.fShowActions()
      this.fGetComplaintTasks()
    },

    // Devuelve el listado de denuncias creadas
    fGetComplaintTasks(){
      this.dLoadingTable = true
      let payload = {
        complaintId: this.pComplaintInfo.complaintId,
        search: this.dSearch,
        searchCols: 'taskTitle, status, responsible',
      }
      ServiceEcomplaints.getComplaintTasks(payload).then(response => {
        this.dTasks = response.dataRes
      }).catch(error => {
        this.fSnackbarError(error, this.pShowSnackbar)
      }).finally(() => {
        this.dLoadingTable = false
      })
    },

    //Muestra u oculta las acciones de las tareas en función del estado general de la denuncia
    fShowActions(){
       if( this.pComplaintInfo.status === 'ACEPTADA' 
        || this.pComplaintInfo.status === 'TRAMITE' 
        || this.pComplaintInfo.status === 'REABIERTA' 
        || this.pComplaintInfo.status === 'NUEVA' ){
          return true
        }
    },

    // Actualiza el orden de las tareas en bbdd
    fUpdateTasksOrder(taskArray){
      let payload = {
        taskArray: taskArray
      }
      ServiceEcomplaints.updateTasksOrder(payload).then(response => {
        if (response.statusCode == '200' && response.result != 'ko'){
          this.fInitTable()
        }
      }).catch(error => {
        this.fSnackbarError(error, this.pShowSnackbar)
      })
    },    

    // Abre la modal de detalle de la tarea
    fOpenTaskDetail(task){
      this.dSelectedTask = task
      this.dShowTaskDetail = true
    },

    // Cierra la modal de detalle de la tarea
    fCloseTaskDetail(update){
      this.dShowTaskDetail = false 
      if(update){
        this.fInitTable()
      }
    },

    // Abre la modal para crear una nueva tarea 
    fNewTask(){
      this.dSelectedTask = null
      this.dShowTaskDetail = true
    },
 
    // Reordena el índice de las tareas si alguno de los elementos se mueve
    fReorderTasks(taskArray) {
      taskArray.forEach((item, index) => (
        item.taskOrder = index))
    
      this.fUpdateTasksOrder(taskArray)
    },

    // Alerta de borrado de tarea
    fDeleteTaskAlert(compType){
      this.dSelectedTask = compType

      const alert = {
        text: this.$t('datAlert.deleteComplaint'),
        action: this.fDelTaskPDA,
        icon: 'mdi-information-outline',
        btnText: this.$t('datBtn.accept'),
        btnTextCancel: this.$t('datBtn.cancel'),
        type: 'warning'
      }

      this.$bus.$emit('showAlert', alert)
    },

    // Elimina el tipo de denuncia desde las tarjetas
    fDelTaskPDA() {
      const payload = {
        complaintId: this.dSelectedTask.complaintId,
        taskTitle: this.dSelectedTask.taskTitle,
        taskOrder: this.dSelectedTask.taskOrder
      }

      ServiceEcomplaints.delTaskPDA(payload).then((response) => {
        if (response.statusCode === '200' && response.infoMsg.code === 0) {
          this.fSnackBarSuccess(this.$t("datAlert.deleteTask"))
          this.fInitTable()
        }
      }).catch((error) => {
        this.fSnackbarError(error, this.pShowSnackbar)
      })
    },    
  },

  watch:{
    dSearch(){
			clearTimeout(this.dCurrentSearchTime)
			this.dCurrentSearchTime = setTimeout(() => {
				this.fGetComplaintTasks()
			}, 1000)
    }
  }
}
</script>